module.exports = __webpack_public_path__ + "media/packs/images/flags/EG-42b3967c29b9d81f370a5da677ce46b4.png";